import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const SELECTORS = {
	section: '.section-youtube-feed',
	thumb: '.js-youtube-feed-thumb',
	featured: '.js-youtube-feed-featured',
	featuredImg: '.js-youtube-feed-featured-img',
	featuredTitle: '.js-youtube-feed-featured-title',
	featuredDate: '.js-youtube-feed-featured-date',
	featuredLinkMedia: '.js-youtube-feed-featured-link-media',
	featuredLinkLogo: '.js-youtube-feed-featured-link-logo',
	featuredButton: '.js-youtube-feed-featured-button',
	mobileSlider: '.js-youtube-feed-mobile-slider',
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
};

const dataOrDefault = function( $el, attrName, fallback ) {
	return $el.attr( attrName ) || fallback;
};

const applySelection = function( $section, $thumb ) {
	const imageUrl = $thumb.attr( 'data-image' );
	const title = dataOrDefault( $thumb, 'data-title', '' );
	const date = dataOrDefault( $thumb, 'data-date', '' );
	const youtubeUrl = dataOrDefault( $thumb, 'data-youtube-url', '#' );
	const youtubeTarget = dataOrDefault( $thumb, 'data-youtube-target', '_self' );
	const buttonUrl = dataOrDefault( $thumb, 'data-button-url', '#' );
	const buttonTarget = dataOrDefault( $thumb, 'data-button-target', '_self' );
	const buttonTitle = dataOrDefault( $thumb, 'data-button-title', '' );
	const hasButton = $thumb.attr( 'data-has-button' ) === '1';

	const $featured = $section.find( SELECTORS.featured );
	const $img = $featured.find( SELECTORS.featuredImg );
	const $titleEl = $featured.find( SELECTORS.featuredTitle );
	const $dateEl = $featured.find( SELECTORS.featuredDate );
	const $button = $featured.find( SELECTORS.featuredButton );

	$img.attr( 'src', imageUrl );
	$titleEl.text( title );
	$dateEl.text( date );
	$section.find( SELECTORS.featuredLinkMedia ).attr( 'href', youtubeUrl ).attr( 'target', youtubeTarget );
	$section.find( SELECTORS.featuredLinkLogo ).attr( 'href', youtubeUrl ).attr( 'target', youtubeTarget );
	$button
		.attr( 'href', buttonUrl )
		.attr( 'target', buttonTarget )
		.text( buttonTitle )
		.toggleClass( 'is-hidden', !hasButton );

	$section.find( SELECTORS.thumb ).each( function() {
		const $btn = $( this );
		const isSelected = $btn[0] === $thumb[0];
		$btn.toggleClass( 'is-active', isSelected );
		$btn.attr( 'aria-pressed', isSelected ? 'true' : 'false' );
	} );
};

const initMobileSlider = function( $section ) {
	const $slider = $section.find( SELECTORS.mobileSlider );

	if ( !$slider.length || $slider[0].swiper ) {
		return;
	}

	new Swiper( $slider[0], {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 600,
		watchOverflow: true,
		autoHeight: true,
		navigation: {
			nextEl: $slider.find( SELECTORS.nextButton )[0],
			prevEl: $slider.find( SELECTORS.prevButton )[0],
		},
	} );
};

const initBlock = function( $block ) {
	$block.each( function() {
		const $section = $( this );

		$section.on( 'click', SELECTORS.thumb, function( e ) {
			const $thumb = $( this );
			if ( $thumb.hasClass( 'is-active' ) ) {
				return;
			}
			e.preventDefault();
			applySelection( $section, $thumb );
		} );

		initMobileSlider( $section );
	} );
};

app.loadBlock( initBlock, 'youtube-feed', SELECTORS.section );

if ( module.hot ) {
	module.hot.accept();
}
